<template>
    <AclForm :url="url" :role="role" :acls="acls" :errors="errors" v-on:onUpdateAcl="onUpdateAcl" v-on:save="saveAcl"></AclForm>
</template>

<script>
import AclForm from './AclForm'
export default {
  name: 'AclEdit',
  components: {AclForm},
  props: ['url'],
  data () {
    return {
      role: {},
      acls: [],
      errors: {}
    }
  },
  methods: {
    onUpdateAcl (val) {
      this.acls = val
    },
    saveAcl () {
      let self = this

      this.$http
        .put(this.url + `/update/${this.$route.params.id}`, {
          name: self.role.name,
          description: self.role.description,
          acls: self.acls
        }, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.role = res.data.data
            this.$router.push('/admin/acl/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', 'Role ' + this.$translate.t('Edit'))

    let self = this
    this.$http
      .get(this.url + `/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.role = res.data.data

        for (let it in self.role.acls) {
          self.acls.push(self.role.acls[it].path)
        }
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/acl/AclEdit.vue